<script>
    export default {
        name: "FooterMenuList",
        props: {
            list: {
                type: Array,
                required: true,
            },
            isMain: Boolean,
            isSecond: Boolean,
        },
        methods: {
            createPath(path) {
                if (path.includes("#")) {
                    const [name, link] = path.split("#");
                    return { name, hash: `#${link}` };
                }

                if (path.includes("__")) {
                    const [name, slug] = path.split("__");
                    return { name, params: { slug } };
                }

                return { name: path };
            },
        },
        computed: {
            createClass() {
                return {
                    "footer-menu-list--main": this.isMain,
                    "footer-menu-list--second": this.isSecond,
                };
            },
        },
    };
</script>

<template>
    <ul class="footer-menu-list" :class="createClass">
        <slot name="beforeLink"></slot>
        <li v-for="item in list" :key="item.name" class="footer-menu-list__item">
            <router-link
                class="footer-menu-list__link"
                :to="createPath(item.link)"
                :exact="isMain"
                :target="item.link.includes('Document') ? '_blank' : null"
                v-html="item.name"
            >
            </router-link>
        </li>
        <slot></slot>
    </ul>
</template>
